import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { HttpService } from '@core/services/http.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppLoginService {

  constructor(private readonly httpservice: HttpService) { }
     forgotPasswordNotification(request: any): Observable<any> {
    return this.httpservice.post('/registration/forgotPasswordNotification', request);
  }
  recoveryEmailVerification(request: any): Observable<any> {
    return this.httpservice.post('/registration/recoveryEmailVerification', request);
  }
    login(request: { username: string; password: string }): Observable<any> {
    return this.httpservice.post('/registration/authenticate', request);
  }
  resetPassword(request: { userId: string; newPassword: string }): Observable<any> {
    return this.httpservice.post('/registration/reset-password', request);
  }
  updateInternalUser(request: { email: string; username: string; password: string }): Observable<any> {
    return this.httpservice.post(API_ENDPOINTS.UPDATE_INTERNAL_USER, request);
  }
}
